export const mainLinksHeader = [
  { id: 1, label: 'главная', path: '/' },
  { id: 2, label: 'каталог', path: '/catalog' },
  { id: 3, label: 'контакты', path: '/contacts' },
  { id: 4, label: 'отзывы', path: '/reviews' },
  { id: 5, label: 'доставка', path: '/delivery' },
  { id: 6, label: 'о важном и гарантии', path: '/warranty' },
  { id: 7, label: 'оплата', path: '/payment' },

  // { id: 4, label: 'доставка'},
  // { id: 5, label: 'оплата'},
  // { id: 6, label: 'о важном и гарантии'},
]

export const mainLinksFooter = [
  { id: 1, label: 'главная', path: '/' },
  { id: 2, label: 'контакты', path: '/contacts' },
  { id: 3, label: 'доставка', path: '/delivery' },
  { id: 4, label: 'гарантии', path: '/importantAndprivacy' },
  { id: 5, label: 'каталог', path: '/catalog' },
  { id: 6, label: 'оплата', path: '/payment' },  
  { id: 7, label: 'отзывы', path: '/reviews' },  
  { id: 8, label: 'коротко о важном', path: '/important' },  
];

export const headerInfoButton = [
  {title: 'Всегда свежие цветы', path: '/fresh_flowers'},
  {title: 'Фото отчёт', path: '/photo_report'},
  {title: 'Фирменная открытка в подарок', path: '/branded_postcard'},
  // 'Всегда свежие цветы', 'Фото отчёт', 'Фирменная открытка в подарок'
];

export const xdData = [
  {
    id: 1, 
    heading: `Modal 1 heading`,
    title: `Centered Modal`,
    body: `Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
        dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
        consectetur ac, vestibulum at eros.`
  },

  {
    id: 2, 
    heading: `Modal 2 heading`,
    title: `Centered Modal`,
    body: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Laborum, quasi ut. Amet debitis
        est quam porro, dolores, nulla accusantium quod dolor nostrum a
        quis delectus aliquam eligendi, necessitatibus sed doloremque..`
  },

  {
    id: 3, 
    heading: `Modal 3 heading`,
    title: `Centered Modal`,
    body: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum itaque odio reiciendis
      molestiae, perspiciatis sit similique maxime facere? Quae impedit sint minima, tenetur sequi
      ut nostrum nobis excepturi aliquid reprehenderit animi ducimus illum nemo cupiditate autem
      ratione atque. Nisi rem enim voluptatem magni dolores deserunt ducimus, quasi consequuntur odit eum!`
  },
]

export const reviewsDataFake = [
  { 
    id: 1,
    userName: 'Валентина',
    date: '12.11.2024',
    review: 'Замечательный магазин. Спасибо, за прекрасный букет для моей сестрёнки.Все прошло быстро и качественно ',
    rating: 4,
    images: [
      'https://api.floraindia.com/upload/Sskd661q2y1718792031698.webp',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQ3Ib80UXdDJFI-5R_JGap0GlcG_XjV9Sw8WudVp7N1fUQ3Wx1JZhOwYkORe_oYzQXpB8&usqp=CAU',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmiYrC4SeZyx4qkr2H2R_0teTimV34HWg46yNDrl55vTxs2l0I0TlV_wRJ-nxxoNayg7M&usqp=CAU',
      'https://asset.bloomnation.com/c_pad,d_vendor:global:catalog:product:image.png,f_auto,fl_preserve_transparency,q_auto/v1716262001/vendor/3752/catalog/product/2/0/20230211060622_file_63e7d91e91094_63e7d927e784b.jpg',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjQ6TbZY67oivenUf-Y9nm4zq-l1WUCAVOSA&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEoJ-D3drp1cTtx2q83xyTLT0KT4KPFx7rOw&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPnr8OxqzkuqGmDtubC3lF4EIor-VzaeHJF-f5nlCVhzRrl2yuJqkJ8P2sKu2mAgH1D-U&usqp=CAU',
      'https://thumbs.dreamstime.com/b/spring-flowers-bouquet-17927254.jpg',
      'https://m.media-amazon.com/images/I/71SWBYY+AWL._AC_SL1500_.jpg',
      'https://cdn.shopify.com/s/files/1/0507/3754/5401/files/CGPD_ALT_V1_preset_ftd-mx-hero-lv-alt.jpg?v=1707341598&width=1920',
    ], 
    child: {}
  },
  {
    id: 2,
    userName: 'Виктор',
    date: '11.11.2024',
    review: 'Спасибо за подаренные эмоции! Букет очень красивый.',
    rating: 4,
    images: [
      'https://api.floraindia.com/upload/Sskd661q2y1718792031698.webp',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQ3Ib80UXdDJFI-5R_JGap0GlcG_XjV9Sw8WudVp7N1fUQ3Wx1JZhOwYkORe_oYzQXpB8&usqp=CAU',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmiYrC4SeZyx4qkr2H2R_0teTimV34HWg46yNDrl55vTxs2l0I0TlV_wRJ-nxxoNayg7M&usqp=CAU',
      'https://asset.bloomnation.com/c_pad,d_vendor:global:catalog:product:image.png,f_auto,fl_preserve_transparency,q_auto/v1716262001/vendor/3752/catalog/product/2/0/20230211060622_file_63e7d91e91094_63e7d927e784b.jpg',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjQ6TbZY67oivenUf-Y9nm4zq-l1WUCAVOSA&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEoJ-D3drp1cTtx2q83xyTLT0KT4KPFx7rOw&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPnr8OxqzkuqGmDtubC3lF4EIor-VzaeHJF-f5nlCVhzRrl2yuJqkJ8P2sKu2mAgH1D-U&usqp=CAU',
      'https://thumbs.dreamstime.com/b/spring-flowers-bouquet-17927254.jpg',
      'https://m.media-amazon.com/images/I/71SWBYY+AWL._AC_SL1500_.jpg',
      'https://cdn.shopify.com/s/files/1/0507/3754/5401/files/CGPD_ALT_V1_preset_ftd-mx-hero-lv-alt.jpg?v=1707341598&width=1920',
    ]
  },
  { id: 3,
    userName: 'Алексей',
    date: '13.10.2024',
    review: 'все четко,быстро, оперативно. спасибо',
    rating: 3,
    images: [
      'https://api.floraindia.com/upload/Sskd661q2y1718792031698.webp',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQ3Ib80UXdDJFI-5R_JGap0GlcG_XjV9Sw8WudVp7N1fUQ3Wx1JZhOwYkORe_oYzQXpB8&usqp=CAU',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmiYrC4SeZyx4qkr2H2R_0teTimV34HWg46yNDrl55vTxs2l0I0TlV_wRJ-nxxoNayg7M&usqp=CAU',
      'https://asset.bloomnation.com/c_pad,d_vendor:global:catalog:product:image.png,f_auto,fl_preserve_transparency,q_auto/v1716262001/vendor/3752/catalog/product/2/0/20230211060622_file_63e7d91e91094_63e7d927e784b.jpg',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjQ6TbZY67oivenUf-Y9nm4zq-l1WUCAVOSA&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEoJ-D3drp1cTtx2q83xyTLT0KT4KPFx7rOw&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPnr8OxqzkuqGmDtubC3lF4EIor-VzaeHJF-f5nlCVhzRrl2yuJqkJ8P2sKu2mAgH1D-U&usqp=CAU',
      'https://thumbs.dreamstime.com/b/spring-flowers-bouquet-17927254.jpg',
      'https://m.media-amazon.com/images/I/71SWBYY+AWL._AC_SL1500_.jpg',
      'https://cdn.shopify.com/s/files/1/0507/3754/5401/files/CGPD_ALT_V1_preset_ftd-mx-hero-lv-alt.jpg?v=1707341598&width=1920',
    ]
  },
  { 
    id: 4,
    userName: 'Иван',
    date: '12.11.2024',
    review: 'Очень красивые розы! Обязательно куплю в будущем.',
    rating: 4,
    images: [
      'https://api.floraindia.com/upload/Sskd661q2y1718792031698.webp',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQ3Ib80UXdDJFI-5R_JGap0GlcG_XjV9Sw8WudVp7N1fUQ3Wx1JZhOwYkORe_oYzQXpB8&usqp=CAU',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmiYrC4SeZyx4qkr2H2R_0teTimV34HWg46yNDrl55vTxs2l0I0TlV_wRJ-nxxoNayg7M&usqp=CAU',
      'https://asset.bloomnation.com/c_pad,d_vendor:global:catalog:product:image.png,f_auto,fl_preserve_transparency,q_auto/v1716262001/vendor/3752/catalog/product/2/0/20230211060622_file_63e7d91e91094_63e7d927e784b.jpg',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjQ6TbZY67oivenUf-Y9nm4zq-l1WUCAVOSA&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEoJ-D3drp1cTtx2q83xyTLT0KT4KPFx7rOw&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPnr8OxqzkuqGmDtubC3lF4EIor-VzaeHJF-f5nlCVhzRrl2yuJqkJ8P2sKu2mAgH1D-U&usqp=CAU',
      'https://thumbs.dreamstime.com/b/spring-flowers-bouquet-17927254.jpg',
      'https://m.media-amazon.com/images/I/71SWBYY+AWL._AC_SL1500_.jpg',
      'https://cdn.shopify.com/s/files/1/0507/3754/5401/files/CGPD_ALT_V1_preset_ftd-mx-hero-lv-alt.jpg?v=1707341598&width=1920',
    ]
  },
  { 
    id: 5,
    userName: 'Петр',
    date: '12.11.2024',
    review: 'Отличные цветы! Помогут нам стать более красивыми.',
    rating: 4,
    images: [
      'https://api.floraindia.com/upload/Sskd661q2y1718792031698.webp',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQ3Ib80UXdDJFI-5R_JGap0GlcG_XjV9Sw8WudVp7N1fUQ3Wx1JZhOwYkORe_oYzQXpB8&usqp=CAU',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmiYrC4SeZyx4qkr2H2R_0teTimV34HWg46yNDrl55vTxs2l0I0TlV_wRJ-nxxoNayg7M&usqp=CAU',
      'https://asset.bloomnation.com/c_pad,d_vendor:global:catalog:product:image.png,f_auto,fl_preserve_transparency,q_auto/v1716262001/vendor/3752/catalog/product/2/0/20230211060622_file_63e7d91e91094_63e7d927e784b.jpg',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjQ6TbZY67oivenUf-Y9nm4zq-l1WUCAVOSA&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEoJ-D3drp1cTtx2q83xyTLT0KT4KPFx7rOw&s',
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPnr8OxqzkuqGmDtubC3lF4EIor-VzaeHJF-f5nlCVhzRrl2yuJqkJ8P2sKu2mAgH1D-U&usqp=CAU',
      'https://thumbs.dreamstime.com/b/spring-flowers-bouquet-17927254.jpg',
      'https://m.media-amazon.com/images/I/71SWBYY+AWL._AC_SL1500_.jpg',
      'https://cdn.shopify.com/s/files/1/0507/3754/5401/files/CGPD_ALT_V1_preset_ftd-mx-hero-lv-alt.jpg?v=1707341598&width=1920',
    ]
  },
]
